<ng-container *ngIf="areRepsLoading">
  <div class="loading-cover">
    <fa-icon class="me-2" [icon]="faCircleNotch" [spin]="true"></fa-icon> Loading
  </div>
</ng-container>
<ng-container *ngIf="!areRepsLoading">

  <div class="row align-items-end mb-3">
    <div class="col-sm-6">
      <label class="form-label" for="repSelectionDropdown">Rep</label>
      <p-dropdown inputId="repSelectionDropdown" styleClass="w-100" [options]="availableRepOptions" optionLabel="label"
        optionValue="value" placeholder="Select a rep" [filter]="true" filterBy="label" [showClear]="true"
        [(ngModel)]="selectedRepId">
      </p-dropdown>
    </div>
    <div class="col-sm-auto">
      <button class="btn btn-sm btn-primary" type="button" [disabled]="selectedRepId === null" (click)="addRep()">
        <fa-icon class="me-2" [icon]="faPlus"></fa-icon> Add
      </button>
    </div>
  </div>

  <table class="table table-sm table-striped">
    <thead>
      <tr>
        <th scope="col">Rep</th>
        <th scope="col">Title</th>
        <th scope="col">Email</th>
        <th scope="col"># of Surveys</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let m of selectedReps">
        <td><span data-private>{{ getRepName(m.rep) }}</span></td>
        <td>{{ m.rep.title }}</td>
        <td><span data-private>{{ m.rep.email }}</span></td>
        <td>
          <p-inputNumber styleClass="survey-count-input" [ngModel]="m.surveyCount"
            (ngModelChange)="onSurveyCountChanged(m, $event)" [ngModelOptions]="{ standalone: true }" mode="decimal"
            [min]="0" [maxFractionDigits]="0" [useGrouping]="false" [showButtons]="false"
            [inputStyleClass]="'form-control form-control-sm'"
            [attr.aria-label]="'Number of surveys for ' + getRepName(m.rep)">
          </p-inputNumber>
        </td>
        <td class="text-end">
          <button class="btn btn-sm btn-link" type="button" [attr.aria-label]="'Remove ' + getRepName(m.rep)"
            (click)="removeRep(m)">
            <fa-icon [icon]="faTrash"></fa-icon>
          </button>
        </td>
      </tr>
      <tr *ngIf="selectedReps.length === 0">
        <td colspan="5" class="text-muted">No reps selected.</td>
      </tr>
    </tbody>
  </table>
</ng-container>
